import PackageMinusIcon from "@redotech/redo-icons/package-minus_filled.svg";
import { Step } from "@redotech/redo-model/return-flow";
import { addUndeclaredItemFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  AddUndeclaredItemState,
  isAddUndeclaredItemStepValid,
} from "@redotech/redo-model/return-flow-step-valid";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import { produce } from "immer";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const ADD_UNDECLARED_ITEM = (
  Details: React.ComponentType<StepTypeDetailsProps<AddUndeclaredItemState>>,
): StepType<AddUndeclaredItemState, Step.AddUndeclaredItem> => ({
  Details: (props) => React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  description: (state) => state.prompt,
  downstream(state) {
    return state.next ? [{ id: state.next }] : [];
  },
  empty: { prompt: "", scope: "return" },
  fromModel: (model, id) => addUndeclaredItemFromModel(model, id),
  Icon: PackageMinusIcon,
  iconColor: "warning",
  layout: () => BlockLayout.FULL,
  maxDownstream: () => 1,
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  stepDeleted(state, stepId) {
    return produce(state, (draft) => {
      if (draft.next === stepId) {
        draft.next = undefined;
      }
    });
  },
  title: "Add undeclared item",
  toModel(state, id) {
    return {
      type: Step.ADD_UNDECLARED_ITEM,
      customTitle: state.customTitle,
      prompt: state.prompt,
      next: state.next ? id(state.next) : null,
      scope: state.scope,
    };
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(
        `Invalid handle index ${handleIndex} for add-undeclared-item step`,
      );
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  valid: (state) => isAddUndeclaredItemStepValid(state).valid,
});

export { type AddUndeclaredItemState } from "@redotech/redo-model/return-flow-step-valid";
